// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1G2qd","notes":"Notes_notes__1zS6W"};